import React from 'react'
import { modal } from '../../../core/utilities/modal';
import { user } from "../../../core/controllers/user"
import { signupHelper } from "../../../helpers/Signup/index"

export default class ReferralCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            referralLink: null,
        }
    }

    componentDidMount() {
        var currUrl = window.location.href
        var index = 0
        var count = 0
        for (var i = 0; i < currUrl.length; i++) {
            if (currUrl[i] == "/") {
                count += 1
            }
            if (count == 3) {
                index = i
                break
            }
        }

        var referralLink = currUrl.substring(0, index) + "/signup?referral="

        if (user.userInfo) {
            referralLink += user.userInfo.username
        }

        signupHelper.setReferralLink(referralLink)

        this.setState({
            referralLink: referralLink,
        })
    }

    handleCopyLink() {
        this.referralLink.select();
        document.execCommand('copy');
        modal.showInfo("Referral link copied to clipboard successfully!", "success", "top", "center")
    }

    render() {
        return (
            <div class="col-md-8">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Referral Link</h4>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12" style={{marginTop: '25px', marginBottom: '25px'}}>
                                <div class="col-md-12">
                                    <label>Shareable referral link</label>
                                </div>
                                <div class="col-md-8 col-sm-8 col-xs-12">
                                    {this.state.referralLink == null ? (
                                    <input type="text" class="form-control" name="referral_code" value="" id="referral_code" readOnly />
                                    ) : (
                                    <input ref={(referralLink) => this.referralLink = referralLink} type="text" class="form-control" name="referral_code" value={this.state.referralLink} id="referral_code" readOnly />
                                    )}
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-12">
                                    <button type="button" id="copy_link" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleCopyLink.bind(this)}>Copy Link</button>
                                </div>
                            </div>
                        </div>
                        {/* <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    <label>Referral Rewards Account</label>
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12">
                                    <select class="form-control">
                                        <option key="0" value="Default">Select a bank account</option>
                                    </select>
                                </div>
                            </div>
                        </div> */}
                        <div class="row">
                            <div class="header">
                                <h4 class="title">Referral Program Details</h4>
                            </div>
                            <div class="content">
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    - Receive a $20 thank you gift!
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    - A successful referral requires the referred user to sign up using your unique link and subscribe to a paid plan.
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    - Referral rewards will be directly deposited into your default billing bank account.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}; 


// WEBPACK FOOTER //
// app/components/Settings/ReferralProgram/ReferralCode.jsx